import { useAutoneTranslation } from '@autone/translations';
import { isValid } from 'date-fns';
import differenceInDays from 'date-fns/differenceInDays';
import { Sparkles } from 'lucide-react';

import { Badge } from '../../tailwind/Badge';

// The number of days to show the badge after the release date
const DEFAULT_DAYS_COUNT_TO_SHOW_BADGE = 30;

export const NewFeatureBadge = ({
  releaseDate,
  daysCountToShowBadge = DEFAULT_DAYS_COUNT_TO_SHOW_BADGE,
}: {
  releaseDate: string;
  daysCountToShowBadge?: number;
}) => {
  const { common } = useAutoneTranslation();

  const releaseDateAsDate = new Date(releaseDate);
  if (!releaseDate || !isValid(releaseDateAsDate)) {
    return null;
  }

  const shouldShowBadge =
    differenceInDays(new Date(), releaseDateAsDate) < daysCountToShowBadge;

  if (!shouldShowBadge) {
    return null;
  }

  return (
    <Badge className="bg-orange-100 text-white rounded-full">
      <div className="flex items-center gap-1 text-xs">
        <p className="text-white first-letter:uppercase">{common('new')}</p>
        <Sparkles className="w-3 h-3" />
      </div>
    </Badge>
  );
};
